import { createSlice } from "@reduxjs/toolkit"; // Redux에서 상태(state)와 상태를 바꾸는 로직(리듀서)을 한곳에 모아서 “슬라이스” 라는 덩어리로 만들어 줍니다.
import { mokiApi } from "../services/loginApi";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { act } from "react";
import { formatDate } from "../functions/DateConverter";
import { useSelector } from "react-redux";

const initialState = {
  totalData: {}, // API로부터 받아온 모든 데이터를 이 객체에 담습니다
  isLoading: true, // API 호출 중 로딩 상태 표시
  error: false, // 에러 여부 (지금은 사용되지 않음)
  validDateList: [], // 사용 가능한 조회 날짜 목록 (캘린더 등에 이용)
};

export const saleSlice = createSlice({
  name: "saleSlice",
  initialState,
  reducers: {
    clearStore: (state) => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(totalThunks.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(totalThunks.fulfilled, (state, action) => {
        state.totalData = action.payload;

        if ([...state.validDateList].length === 0) {
          const todayDate = formatDate(new Date());
          let list = [];
          list.push(todayDate);
          state.validDateList = [...list];
        }
        state.isLoading = false;
      });
  },
});

export const { clearStore } = saleSlice.actions;

export const totalThunks = createAsyncThunk(
  "saleSlice/fetchData",
  async (initialFormatDate, thunkAPI) => {
    // let data = {"date":initialFormatDate,"today":{},"predictNext":{}, "predictToday":{},"predictLast":{},"predictDetail":{},"rankDetail":{},"rankCompare":{},"menuList":[],'lastDetail':{}}
    // let data = {"date":initialFormatDate,"today":{},"predictNext":{}, "predictLast":{},"predictDetail":{},"rankDetail":{},"rankCompare":{},"menuList":[],'lastDetail':{}}
    let data = {
      date: initialFormatDate,
      today: {},
      predict: {},
      rankDetail: {},
      rankCompare: {},
      menuList: [],
      lastDetail: {},
    };
    //토큰 가져다 쓰기
    const token = sessionStorage.getItem("accessToken");
    if (token) {
      mokiApi.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    }
    //비교를 위한 어제, 일주일 전 , 한달 전 데이터 가져오기
    const yesterday = new Date(initialFormatDate);
    const lastWeek = new Date(initialFormatDate);
    const lastMonth = new Date(initialFormatDate);
    const tomorrow = new Date(initialFormatDate);
    const nextWeek = new Date(initialFormatDate);
    const nextMonth = new Date(initialFormatDate);
    yesterday.setDate(yesterday.getDate() - 1);
    lastWeek.setDate(lastWeek.getDate() - 7);
    lastMonth.setDate(1);
    lastMonth.setMonth(lastMonth.getMonth() - 1);
    tomorrow.setDate(tomorrow.getDate() + 1);
    nextWeek.setDate(nextWeek.getDate() + 7);
    // nextMonth.setDate(nextMonth.getDate()+30)
    nextMonth.setDate(1);
    nextMonth.setMonth(nextMonth.getMonth() + 1);
    // 다음 주의 월요일 구하기
    nextWeek.setDate(nextWeek.getDate() - nextWeek.getDay() + 1);
    // 다음 달의 1일 구하기
    nextMonth.setDate(1); // 1일로 설정

    const formattedYesterday = formatDate(yesterday);
    const formattedLastWeek = formatDate(lastWeek);
    const formattedLastMonth = formatDate(lastMonth);
    const formattedTomorrow = formatDate(tomorrow);
    const formattedNextWeek = formatDate(nextWeek);
    const formattedNextMonth = formatDate(nextMonth);
    const daily_dates = [];
    const weekly_dates = [];
    const monthly_dates = [];
    //daily_dates = 하루단위 매출 얻기위한 날짜들 [2024-07-28,2024-07-27,...]
    //weekly_dates = 주단위 매출 얻기위한 날짜들 [2024-07-28,2024-07-21,...]
    //monthly_dates = 월단위 매출 얻기위한 날짜들 [2024-07-28,2024-06-28,...]
    daily_dates.push(formatDate(yesterday));
    weekly_dates.push(formatDate(lastWeek));
    monthly_dates.push(formatDate(lastMonth));
    for (let i = 1; i < 4; i++) {
      yesterday.setDate(yesterday.getDate() - 1);
      lastWeek.setDate(lastWeek.getDate() - 7);
      // lastMonth.setDate(lastMonth.getDate()-30)
      lastMonth.setDate(1);
      lastMonth.setMonth(lastMonth.getMonth() - 1);
      const seven_days_ago = formatDate(lastWeek);
      const thirthy_days_ago = formatDate(lastMonth);
      const one_day_ago = formatDate(yesterday);
      daily_dates.push(one_day_ago);
      weekly_dates.push(seven_days_ago);
      monthly_dates.push(thirthy_days_ago);
    }

    //API 호출에 걸리는 시간을 알아보기 위한 타임스탬프
    let startTime, endTime;

    try {
      startTime = performance.now();
      const [resDaily, resWeekly, resMonthly] = await Promise.all([
        mokiApi.get(`/api/date/daily`, {
          params: { localDate: initialFormatDate },
        }),
        mokiApi.get(`/api/date/weekly`, {
          params: { localDate: initialFormatDate },
        }),
        mokiApi.get(`/api/date/monthly`, {
          params: { localDate: initialFormatDate },
        }),
      ]);
      data.today = {
        daily: resDaily.data,
        weekly: resWeekly.data,
        monthly: resMonthly.data,
      };
      endTime = performance.now();
      // console.log(`호출한 API : /api/date/`);
      // console.log(`소요시간 : ${(endTime - startTime).toFixed(2)}ms`);
    } catch (error) {
      data.today.daily = {};
      data.today.weekly = {};
      data.today.monthly = {};
      console.log(error);
    }

    try {
      startTime = performance.now();
      const [resDaily, resWeekly, resMonthly] = await Promise.all([
        mokiApi.get(`/api/predict/daily`, {
          params: { localDate: initialFormatDate },
        }),
        mokiApi.get(`/api/predict/weekly`, {
          params: { localDate: initialFormatDate },
        }),
        mokiApi.get(`/api/predict/monthly`, {
          params: { localDate: initialFormatDate },
        }),
      ]);
      data.predict = {
        daily: resDaily.data,
        weekly: resWeekly.data,
        monthly: resMonthly.data,
      };
      endTime = performance.now();
      // console.log(`호출한 API : /api/predict/`);
      // console.log(`소요시간 : ${(endTime - startTime).toFixed(2)}ms`);
    } catch (error) {
      data.predict.daily = {};
      data.predict.weekly = {};
      data.predict.monthly = {};
      console.log(error);
    }
    try {
      startTime = performance.now();
      const response = await mokiApi.get(`/api/sale/daily-detail`, {
        params: {
          localDate: initialFormatDate,
        },
      });
      if (
        response.status == 200 &&
        response.data.saleGetResList !== undefined
      ) {
        data.rankDetail.daily = response.data.saleGetResList;
      }
      endTime = performance.now();
      // console.log(`호출한 API : /api/sale/daily-detail`);
      // console.log(`소요시간 : ${(endTime - startTime).toFixed(5)}ms`);
    } catch (error) {
      data.rankDetail.daily = [];
      console.log(error);
    }
    try {
      startTime = performance.now();
      const response = await mokiApi.get(`/api/sale/weekly-detail`, {
        params: {
          localDate: initialFormatDate,
        },
      });
      if (
        response.status == 200 &&
        response.data.saleGetResList !== undefined
      ) {
        data.rankDetail.weekly = response.data.saleGetResList;
      }
      endTime = performance.now();
      // console.log(`호출한 API : /api/sale/weekly-detail`);
      // console.log(`소요시간 : ${(endTime - startTime).toFixed(5)}ms`);
    } catch (error) {
      data.rankDetail.weekly = [];
      console.log(error);
    }

    try {
      startTime = performance.now();
      const response = await mokiApi.get(`/api/sale/monthly-detail`, {
        params: {
          localDate: initialFormatDate,
        },
      });
      if (
        response.status == 200 &&
        response.data.saleGetResList !== undefined
      ) {
        data.rankDetail.monthly = response.data.saleGetResList;
      }
      endTime = performance.now();
      // console.log(`호출한 API : /api/sale/monthly-detail`);
      // console.log(`소요시간 : ${(endTime - startTime).toFixed(5)}ms`);
    } catch (error) {
      data.rankDetail.monthly = [];
      console.log(error);
    }

    //어제 매출 디테일
    try {
      startTime = performance.now();
      const response = await mokiApi.get(`/api/sale/daily-detail`, {
        params: {
          localDate: formattedYesterday,
        },
      });
      if (
        response.status == 200 &&
        response.data.saleGetResList !== undefined
      ) {
        //구한 값 state에 집어 넣기
        data.lastDetail["daily"] = response.data.saleGetResList;
      }
      endTime = performance.now();
      // console.log(`호출한 API : /api/sale/daily-detail 어제`);
      // console.log(`소요시간 : ${(endTime - startTime).toFixed(5)}ms`);
    } catch (error) {
      data.lastDetail["daily"] = [];
      console.log(error);
    }

    //지난주와 오늘 비교
    try {
      startTime = performance.now();
      const response = await mokiApi.get(`/api/sale/weekly-detail`, {
        params: {
          localDate: formattedLastWeek,
        },
      });
      if (
        response.status == 200 &&
        response.data.saleGetResList !== undefined
      ) {
        //구한 값 state에 집어 넣기
        data.lastDetail["weekly"] = response.data.saleGetResList;
      }
      endTime = performance.now();
      // console.log(`호출한 API : /api/sale/weekly-detail 지난주`);
      // console.log(`소요시간 : ${(endTime - startTime).toFixed(5)}ms`);
    } catch {
      data.lastDetail["weekly"] = [];
    }

    try {
      startTime = performance.now();
      const response = await mokiApi.get(`/api/sale/monthly-detail`, {
        params: {
          localDate: formattedLastMonth,
        },
      });
      if (
        response.status == 200 &&
        response.data.saleGetResList !== undefined
      ) {
        //구한 값 state에 집어 넣기
        data.lastDetail["monthly"] = response.data.saleGetResList;
      }
      endTime = performance.now();
      // console.log(`호출한 API : /api/sale/monthly-detail 지난달`);
      // console.log(`소요시간 : ${(endTime - startTime).toFixed(5)}ms`);
    } catch {
      data.lastDetail["monthly"] = [];
    }

    try {
      startTime = performance.now();
      const response = await mokiApi.get(`/api/menu/list`);
      data.menuList = response.data;
      endTime = performance.now();
      // console.log(`호출한 API : /api/menu/list`);
      // console.log(`소요시간 : ${(endTime - startTime).toFixed(5)}ms`);
    } catch (error) {
      data.menuList = [];
      console.log(error);
    }

    return data;
  }
);

// //일단위 오늘 비교
// try{
//   startTime = performance.now();
//   count = 1;
//   for(const dates of daily_dates){
//     count = count + 1;
//     const response = await mokiApi.get(`/api/date/daily`, {
//       params: {
//         localDate: dates,
//       },
//     })
//     if (response.status == 200 && response.data.today !== undefined){
//       compare_data[dates] = response.data.today;
//     }
//   }

//   //구한 값 state에 집어 넣기
//   data.rankCompare.daily = compare_data
//   endTime = performance.now();
//   console.log(`호출한 API : /api/date/daily for문 ${count}회`);
//   console.log(`StartTime : ${startTime}, EndTime : ${endTime}`);
//   console.log(`소요시간 : ${(endTime-startTime).toFixed(5)}ms`);
// }
// catch(error){
//   data.rankCompare.daily = compare_data
//   console.log(error)
// }

// try {
//   startTime = performance.now();
//   const response = await mokiApi.get(`/api/predict/daily`, {
//     params: {
//       localDate: initialFormatDate,
//     },
//   });
//   data.predict.daily = response.data;
//   endTime = performance.now();
//   console.log(`호출한 API : /api/predict/`);
//   console.log(`StartTime : ${startTime}, EndTime : ${endTime}`);
//   console.log(`소요시간 : ${(endTime - startTime).toFixed(5)}ms`);
// } catch (error) {
//   data.predict.monthly = {};
//   console.log(error);
// }
// try {
//   startTime = performance.now();
//   const response = await mokiApi.get(`/api/predict/weekly`, {
//     params: {
//       localDate: initialFormatDate,
//     },
//   });
//   data.predict.weekly = response.data;
//   endTime = performance.now();
//   console.log(`호출한 API : /api/predict/weekly`);
//   console.log(`StartTime : ${startTime}, EndTime : ${endTime}`);
//   console.log(`소요시간 : ${(endTime - startTime).toFixed(5)}ms`);
// } catch (error) {
//   data.predict.weekly = {};
//   console.log(error);
// }
// try {
//   startTime = performance.now();
//   const response = await mokiApi.get(`/api/predict/monthly`, {
//     params: {
//       localDate: initialFormatDate,
//     },
//   });
//   data.predict.monthly = response.data;
//   endTime = performance.now();
//   console.log(`호출한 API : /api/predict/monthly`);
//   console.log(`StartTime : ${startTime}, EndTime : ${endTime}`);
//   console.log(`소요시간 : ${(endTime - startTime).toFixed(5)}ms`);
// } catch (error) {
//   data.predict.monthly = {};
//   console.log(error);
// }

// try{
//   const response = await mokiApi.get(`/api/predict/daily-detail`, {
//     params: {
//       localDate: formattedTomorrow,
//     },
//   })
//   data.predictNext.daily = response.data
//   data.predictNext.daily.date = formattedTomorrow

// }
// catch(error){
//   data.predictNext.monthly = {}
//   console.log(error)
// }
// try{
//   const response = await mokiApi.get(`/api/predict/weekly-detail`, {
//     params: {
//       localDate: formattedNextWeek,
//     },
//   })

//   data.predictNext.weekly = response.data
//   data.predictNext.weekly.date = formattedNextWeek

// }
// catch(error){
//   data.predictNext.weekly = {}
//   console.log(error)
// }

// try{
//   const response = await mokiApi.get(`/api/predict/monthly-detail`, {
//     params: {
//       localDate: formattedNextMonth,
//     },
//   })

//   data.predictNext.monthly = response.data
//   data.predictNext.monthly.date = formattedNextMonth
// }
// catch(error){
//   data.predictNext.monthly = {}
//   console.log(error)
// }

// try{
//   const response = await mokiApi.get(`/api/predict/daily-detail`, {
//     params: {
//       localDate: initialFormatDate,
//     },
//   })
//   data.predictDetail.daily = response.data
// }
// catch(error){
//   data.predictDetail.daily = {}
//   console.log(error)
// }
// try{
//   const response = await mokiApi.get(`/api/predict/weekly-detail`, {
//     params: {
//       localDate: initialFormatDate,
//     },
//   })
//   data.predictDetail.weekly= response.data
// }
// catch(error){
//   data.predictDetail.weekly = {}
//   console.log(error)
// }
// try{
//   const response = await mokiApi.get(`/api/predict/monthly-detail`, {
//     params: {
//       localDate: initialFormatDate,
//     },
//   })
//   data.predictDetail.monthly = response.data
// }
// catch(error){
//   data.predictToday.monthly = {}
//   console.log(error)
// }

// //지난주 주간 매출 디테일
// try{
//   startTime = performance.now();
//   count = 1;
//   for(const dates of weekly_dates){
//     count = count + 1;
//     const response = await mokiApi.get(`/api/date/weekly`, {
//       params: {
//         localDate: dates,
//       },
//     })
//     if (response.status == 200 && response.data.today !== undefined){
//       compare_data[dates] = response.data.today;
//     }
//   }
//   //구한 값 state에 집어 넣기
//   data.rankCompare.weekly = compare_data
//   endTime = performance.now();
//   console.log(`호출한 API : /api/date/weekly for문 ${count}회`);
//   console.log(`StartTime : ${startTime}, EndTime : ${endTime}`);
//   console.log(`소요시간 : ${(endTime-startTime).toFixed(5)}ms`);
// }
// catch(error){
//   data.rankCompare.weekly= compare_data
//   console.log(error)
// }

//지난달과 이번달 비교
// try{

//   //지난달 월간 매출 디테일
//   startTime = performance.now();
//   count = 1;
//   for(const dates of monthly_dates){
//     count = count + 1;
//     const response = await mokiApi.get(`/api/date/monthly`, {
//       params: {
//         localDate: dates,
//       },
//     })
//     if (response.status == 200 && response.data.today !== undefined){
//       compare_data[dates] = response.data.today;
//     }
//   }
//   //구한 값 state에 집어 넣기
//   data.rankCompare.monthly = compare_data
//   endTime = performance.now();
//   console.log(`호출한 API : /api/date/monthly for문 ${count}회`);
//   console.log(`StartTime : ${startTime}, EndTime : ${endTime}`);
//   console.log(`소요시간 : ${(endTime-startTime).toFixed(5)}ms`);
// }
// catch(error){
//   data.rankCompare.monthly= compare_data
//   console.log(error)
// }

/*
 **  Promise로 3개의 API 호출을 하나로 묶음
 **  원래의 API호출은 주석처리
 */

/*
    try{
      startTime = performance.now();
      const response = await mokiApi.get(`/api/date/daily`, {
        params: {
          localDate: initialFormatDate,
        },
      })
      data.today.daily = response.data
      endTime = performance.now();
      console.log(`호출한 API : /api/date/daily`);
      console.log(`StartTime : ${startTime}, EndTime : ${endTime}`);
      console.log(`소요시간 : ${(endTime-startTime).toFixed(5)}ms`);
    }
    catch(error){
      data.today.daily = {}
      console.log(error)
    }

    try{
      startTime = performance.now();
      const response = await mokiApi.get(`/api/date/weekly`, {
        params: {
          localDate: initialFormatDate,
        },
      })
      data.today.weekly = response.data
      endTime = performance.now();
      console.log(`호출한 API : /api/date/weekly`);
      console.log(`StartTime : ${startTime}, EndTime : ${endTime}`);
      console.log(`소요시간 : ${(endTime-startTime).toFixed(5)}ms`);
    }
    catch(error){
      data.today.weekly = {}
      console.log(error)
    }

    try{
      startTime = performance.now();
      const response = await mokiApi.get(`/api/date/monthly`, {
        params: {
          localDate: initialFormatDate,
        },
      })
      data.today.monthly = response.data
      endTime = performance.now();
      console.log(`호출한 API : /api/date/monthly`);
      console.log(`StartTime : ${startTime}, EndTime : ${endTime}`);
      console.log(`소요시간 : ${(endTime-startTime).toFixed(5)}ms`);
    }
    catch(error){
      data.today.monthly = {}
      console.log(error)
    }
    */

// try{
//   const response = await mokiApi.get(`/api/predict/daily`, {
//     params: {
//       localDate: initialFormatDate,
//     },
//   })
//   data.predictToday.daily = response.data
// }
// catch(error){
//   data.predictToday .daily= {}
//   console.log(error)
// }
// try{
//   const response = await mokiApi.get(`/api/predict/weekly`, {
//     params: {
//       localDate: initialFormatDate,
//     },
//   })
//   data.predictToday.weekly = response.data
// }
// catch(error){
//   data.predictToday.weekly = {}
//   console.log(error)
// }
// try{
//   const response = await mokiApi.get(`/api/predict/monthly`, {
//     params: {
//       localDate: initialFormatDate,
//     },
//   })
//   data.predictToday.monthly = response.data
// }
// catch(error){
//   data.predictToday.monthly = {}
//   console.log(error)
// }

// 예측값과 실제 매출값 비교를 위한 어제, 지난주, 지난달 예측값
